import Swiper from "swiper";
import "../sass/index.scss";

//Components
import "./components/navigation.js";
import "./components/slideshows.js";
//import "./components/header.js";
import "./components/webform-popup.js";
import "./components/location-bike-slideshow.js";
import "./components/alert-popup.js";
import "./components//webform.js";
import "./components/video-popup.js";
import "./components/commerce-cart.js";
import "./components/banner-image.js";
import "./components/svg-header-slideshow.js";
import "./select/select.js";

//Pages
import "./pages/landing-page.js";
import "./pages/tours.js";

//Misc
//import "./misc/svgAnimation.js";
import "./misc/category-activator.js";
import "./misc/location-selector.js";
import "./misc/city-selector.js";
import "./misc/alcatraz-redirect.js";
import "./misc/misc.js";
import "./misc/sticky.js";

/* document.addEventListener('touchmove', function (event) {
    if (event.scale !== 1) { event.preventDefault(); }
  }, { passive: false }); */

  document.addEventListener('touchmove', function(event) {
    if (event.scale !== 1 && event.touches.length > 1) {
      event.preventDefault();
    }
  }, { passive: false });
  
  document.addEventListener("DOMContentLoaded", function() {
    if(document.querySelector(".generic-swiper")) {
      let mySwiper;
    
      mySwiper = new Swiper(".generic-swiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        grabCursor: true,
        loop: true,
        autoplay: {
          delay: 3000, 
        },
        threshold: 50,
      });
    }
});

